import { Helmet } from "react-helmet"
import MasterGamesList from "../data/MasterGamesList"
import ProvidersData from "../data/ProvidersData"
export const currentPath = window.location.pathname
export const currentDomain = window.location.origin

function SlotsGames() {
  return (
    <>
      <Helmet>
        <meta charSet="utf-8" />
        <title>Slots - FGH - Your One-Stop Gaming Site</title>
        <link rel="icon" href="/images/fav.webp" sizes="32x32" />
        <meta
          name="description"
          content="Play top-rated online slots at FGH Casino PH. Fast wins, easy GCash/Maya deposits & cashouts. Safe play for Filipino players 21+."
        />
        <link rel="canonical" href={`${currentDomain}${currentPath}`} />
      </Helmet>
      {/* <div className="testchat"><LiveChatWidget license="11142882" visibility="minimized" /></div> */}
      <section className="main-body-content main-container-global-adjusted-padding">
        <div className="fgh-slot-games-page-main">
          <div className="fgh-section-margin fgh-home-provider-games">
            <ProvidersData />
          </div>
          <div className="fgh-heading-container">
            <h1 className="fgh-h1-style normal-margin-bottom">
              Best Online Slot Games in Asia
            </h1>
            <br />

            <label className="fgh-normal-label-style standard-margin-bottom">
              (JILI, Pragmatic Play, RTG, Fachai & More)
            </label>
          </div>
          <div className="fgh-slots-games">
            <MasterGamesList
              limit={60}
              tools="on"
              recentgames="showall"
              headerText="Top Games you can play"
              headerTag="h2"
            />
          </div>
          <div className="fgh-section-margin fgh-section-articles">
            <div className="fgh-main-page-content">
              <h2 className="fgh-h2-style standard-margin-bottom">
                FGH – Best Casino Site, Just for You
              </h2>
              <p className="fgh-paragraph-standard-style">
                Get ready to spin, win, and have a blast! At FGH, we bring you a
                thrilling collection of online slots designed to keep the
                excitement rolling. Whether you're here for big wins, fun
                themes, or just some good old-fashioned luck, we’ve got
                something for everyone. No complicated rules, just pure
                entertainment at your fingertips!
              </p>
              <p className="fgh-paragraph-standard-style">
                So, why wait? Dive into the action, explore our wide range of
                slots, and let the reels do the talking. Who knows? Your next
                spin could be the lucky one!{" "}
              </p>
            </div>
          </div>
        </div>
      </section>
    </>
  )
}

export default SlotsGames
